import React from 'react';
import './TrustedBySection.css';
import WhyCognitva from './WhyCognitva';

const companies = [
  { name: 'Lumina', icon: <img src="/images/objects.svg" alt="objects icon" /> },
  { name: 'Vortex', icon: <img src="/images/objects1.svg" alt="objects1 icon" /> },
  { name: 'Velocity', icon: <img src="/images/objects2.svg" alt="objects2 icon" /> },
  { name: 'Synergy', icon: <img src="/images/capa1.svg" alt="capa1 icon" /> },
  { name: 'Enigma', icon: <img src="/images/frame4.svg" alt="frame4 icon" /> },
  { name: 'Spectrum', icon: <img src="/images/frame5.svg" alt="frame5 icon" /> }
];

const TrustedBySection = () => {
  const duplicatedCompanies = [...companies, ...companies];

  return (
      <div className="trusted-by-section">
        <div className="trusted-by-text">
        Pilot customer & used by top industry professionals
        </div>
        <div className="trusted-by-container">
          <div className="trusted-by-logos-row">
            {duplicatedCompanies.map((company, idx) => (
              <React.Fragment key={`${company.name}-${idx}`}>
                <div className="trusted-by-logo">
                  <span className="trusted-by-logo-icon">{company.icon}</span>
                  <span className="trusted-by-logo-name">{company.name}</span>
                </div>
                {idx < duplicatedCompanies.length - 1 && <img src="/images/separator.svg" alt="separator" className="trusted-by-separator" />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    
  );
};

export default TrustedBySection;